import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import getUserFromToken from "../../utils/getUserFromToken";

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const userId = getUserFromToken();
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.clear();
        toast.success("Logged Out");
        navigate("/admin/auth/login");
    };

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const response = await axios.post("/user/reset-password", {
                userId,
                oldPassword: values.oldPassword, // Assuming you need to provide the old password
                newPassword: values.newPassword,
            });

            if (response.status === 200) {
                message.success("Password changed successfully");
                handleLogout(); // Log the user out after successful password change
            } else {
                message.error("Failed to change password");
            }
        } catch (error) {
            // Handle error based on backend response
            if (error.response && error.response.status === 400) {
                const errorMessage = error.response.data.message;
                
                if (errorMessage === "Old password is incorrect") {
                    toast.error("Old password is incorrect");
                } else if (errorMessage === "New password cannot be the same as the old password") {
                    toast.error("New password cannot be the same as the old password");
                } else {
                    message.error("Failed to change password");
                }
            } else {
                message.error("Failed to change password");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "top" }}>
            <Card style={{ width: 400, padding: "20px" }}>
                <h2 style={{ textAlign: "center", marginBottom: "20px", fontWeight: "bold", fontSize: '20px' }}>Reset Password</h2>
                <Form
                    name="reset_password"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="oldPassword"
                        label="Old Password"
                        rules={[{ required: true, message: "Please enter your old password!" }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Enter old password" />
                    </Form.Item>

                    <Form.Item
                        name="newPassword"
                        label="New Password"
                        rules={[{ required: true, message: "Please enter your new password!" }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Enter new password" />
                    </Form.Item>

                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        dependencies={["newPassword"]}
                        rules={[
                            { required: true, message: "Please confirm your password!" },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("newPassword") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("Passwords do not match!"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Confirm new password" />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={loading}
                        >
                            Reset Password
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default ResetPassword;
